import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19d613d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-0.5" }

import { IncrediSelect } from 'incredi-ui';
import { User, UsersDocument, User_Role, User_Status, useUsersQuery } from '@/graphql/codegen/generated/graphql';
import { CONST_NOTIFY } from '@/services/notify/CONST';
import { useNotify } from '@/services/notify/notify';
import { useI18n } from 'vue-i18n';
import apolloClient from '@/plugins/GraphQL/Apollo/client';
import { MAP_User_Roles_To_Show, MAP_COLUMNS_To_User_Roles } from '../../users-table.const';
import { useUsersActions } from '../../../users.helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserRoleCell',
  props: {
    borderless: { type: Boolean },
    isActive: { type: Boolean },
    user: null,
    modelValue: null,
    selected: { type: Boolean }
  },
  emits: ["update:user", "menu-visibility"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line no-unused-vars
  (e: 'update:user', user: User): void;
  // eslint-disable-next-line no-unused-vars
  (e: 'menu-visibility', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  borderless: boolean;
  isActive: boolean;
  user?: User | null;
  modelValue?: User_Role | null;
  selected?: boolean;
}

const users = useUsersQuery({}, { fetchPolicy: 'cache-first' });
const { setUpdateUserAction } = useUsersActions();
const { toastMessage } = useNotify();
const { t } = useI18n();





const emitVisibility = (value: boolean) => {
  emit('menu-visibility', value);
};

const handleUpdated = async (value: User_Role) => {
  // calculating number of admin users that are active.
  const gridAdminNumber = users.result.value?.users?.filter(user => user?.role === User_Role.GridAdmin && user.status === User_Status.Active).length;
  // returning true if user is last admin. If user is last admin, he can't change his role.
  const isUserLastAdmin = props.user?.role === User_Role.GridAdmin && props.user.status === User_Status.Active && gridAdminNumber === 1 && value !== User_Role.GridAdmin;
  if (props.user?.id && !isUserLastAdmin) {
    try {
      const result = await setUpdateUserAction(props.user?.id, { role: value });
      if (result?.data?.user_update) {
        apolloClient.writeQuery({
          query: UsersDocument,
          variables: {
            filter: {},
          },
          data: { users: users.result.value?.users?.map(user => (user?.id === result?.data?.user_update?.id ? (result?.data?.user_update as typeof user) : user)) },
        });
        toastMessage(t('usersTable.userRole.success'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
      }
    } catch (e) {
      toastMessage(t('usersTable.userRole.fail'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
    }
  } else {
    toastMessage(t('usersTable.userRole.lastAdmin'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IncrediSelect), {
      items: Object.values(_unref(MAP_User_Roles_To_Show)),
      "model-value": _unref(MAP_User_Roles_To_Show)[__props.modelValue as User_Role],
      class: _normalizeClass(["-px-0.5", { 'not-active': !__props.isActive && !__props.selected }]),
      size: "tiny",
      borderless: __props.borderless,
      direction: "bottom-sticky-left",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) =>handleUpdated(_unref(MAP_COLUMNS_To_User_Roles)[value as keyof typeof MAP_COLUMNS_To_User_Roles])),
      onMenuVisibility: _cache[1] || (_cache[1] = ($event: any) => (emitVisibility($event)))
    }, null, 8, ["items", "model-value", "borderless", "class"])
  ]))
}
}

})